import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const AttachmentContainer = styled.div`
    margin-top: ${token('space.100', '8px')};
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const AttachmentFileName = styled.div`
    ${mixins.clamp}
    margin-bottom: ${token('space.100', '8px')};
    flex: 1 1 auto;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const AttachmentMessage = styled.div`
    flex: 0 0 auto;
    margin-left: ${token('space.100', '8px')};
    white-space: nowrap;
    color: ${token('color.text.subtlest', colors.N300)};
`;

const UPLOAD_STATUS_ICON_SIZE = grid.multiple(4).px;
// eslint-disable-next-line rulesdir/no-styled-export
export const UploadStatusPreview = styled.img`
    height: ${UPLOAD_STATUS_ICON_SIZE};
    width: ${UPLOAD_STATUS_ICON_SIZE};
`;

// Progress Bar - Replace with AtlasKit version when available
const progressBarHeight = '6px';

// eslint-disable-next-line rulesdir/no-styled-export
export const UploadProgressBarContainer = styled.div`
    ${mixins.borderRadius};
    margin-bottom: ${token('space.100', '8px')};
    height: ${progressBarHeight};
    width: 100%;
    background: ${token('color.background.neutral', colors.N30A)};
`;

interface UploadProgressProps {
    progress: number;
}

const UploadProgressBar = styled.div`
    ${mixins.borderRadius};
    height: ${progressBarHeight};
`;

export const UploadProgressBarInProgress = UploadProgressBar.extend`
    width: ${(props: UploadProgressProps) => props.progress || 0}%;
    background: ${token('color.background.neutral.bold', colors.N800)};
`;

export const UploadProgressBarFailure = UploadProgressBar.extend`
    width: 100%;
    background: ${token('color.background.danger.bold', colors.R300)};
`;
